<template>
    <div>
        <h3 class="columnTit mt10"><span>书画</span></h3>
        <div class="hotList">
            <el-tabs value="first">
                <AdvClass :advCode="'nfphk1087'" :isDD="true" :ddCode="'utbku1114'"></AdvClass>
                <el-tab-pane label="国画" name="first" v-if="classData.guohua">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.guohua">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="书法" name="second" v-if="classData.shufa">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.shufa">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}"  target="_blank">
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>瓷器杂项</span></h3>
        <div class="hotList">
            <el-tabs value="first">
                <AdvClass :advCode="'mbafs1088'" :isDD="true" :ddCode="'agmbh1115'"></AdvClass>
                <el-tab-pane label="陶瓷" name="first" v-if="classData.taoci">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.taoci">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="玉石器" name="second" v-if="classData.yushiqi">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.yushiqi">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="紫砂" name="third" v-if="classData.zisha">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.zisha">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="铜器" name="four" v-if="classData.tongqi">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.tongqi">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>油画及当代艺术</span></h3>
        <div class="hotList">

            <el-tabs value="first">
                <AdvClass :advCode="'skmer1089'" :isDD="true" :ddCode="'suxvz1116'"></AdvClass>
                <el-tab-pane label="油画" name="first" v-if="classData.youhua">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.youhua">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="当代艺术" name="second" v-if="classData.dangdaiyishu">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.dangdaiyishu">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="版画" name="third" v-if="classData.banhua">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.banhua">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="雕塑" name="four" v-if="classData.diaosu">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.diaosu">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>古籍善本</span></h3>
        <div class="hotList oneTabs">

            <el-tabs value="first">
                <AdvClass :advCode="'suklf1090'" :isDD="true" :ddCode="'grzcz1117'"></AdvClass>
                <el-tab-pane label="综合" name="first" v-if="classData.gujishanben">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.gujishanben">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>邮品钱币</span></h3>
        <div class="hotList oneTabs">

            <el-tabs value="first">
                <AdvClass :advCode="'atyng1091'" :isDD="true" :ddCode="'vawhz1118'"></AdvClass>
                <el-tab-pane label="综合" name="first" v-if="classData.youpinqianbi">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.youpinqianbi">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>珠宝翡翠</span></h3>
        <div class="hotList oneTabs">

            <el-tabs value="first">
                <AdvClass :advCode="'mautk1092'" :isDD="true" :ddCode="'acsed1119'"></AdvClass>
                <el-tab-pane label="综合" name="first" v-if="classData.zhubaofeicui">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.zhubaofeicui">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>名表</span></h3>
        <div class="hotList oneTabs">

            <el-tabs value="first">
                <AdvClass :advCode="'kcabg1093'" :isDD="true" :ddCode="'tloii1120'"></AdvClass>
                <el-tab-pane label="综合" name="first" v-if="classData.mingbiao">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.mingbiao">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
        <h3 class="columnTit mt10"><span>名酒</span></h3>
        <div class="hotList oneTabs">

            <el-tabs value="first">
                <AdvClass :advCode="'qkcrw1094'" :isDD="true" :ddCode="'focmo1121'"></AdvClass>
                <el-tab-pane label="综合" name="first" v-if="classData.mingjiu">
                    <ul class="fix">
                        <template v-for="(item,i) in classData.mingjiu">
                            <li :key="i" v-if="i<2" class="second">
                                <router-link :to="{path:'/paimai-'+item.ArtCode}" target="_blank" >
                                    <div class="imgBox" @click="authorClick(item)">
                                        <el-image
                                            style="width: 100%; height: 100%;"
                                            :src="item.Picture" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="hoverTxt">
                                            <p v-if="item.Date">时间：{{item.Date}}</p>
                                            <p v-if="item.Price">估价：{{item.Price}}</p>
                                            <p v-if="item.SimpleName">公司：{{item.SimpleName}}</p>
                                        </div>
                                    </div>
                                    <div class="hotTit" @click="authorClick(item)">{{ item.AuthorName }} {{item.Title}}</div>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import {getClass} from "@/api/index";
import AdvClass from "@/components/advert/advClass";
// 神策埋点
import { authorClick } from '@/utils/buriedPoint.js'
export default {
    name: "ClassData",
    data(){
        return{
            t:0,
            classData:{
                banhua:[],
                dangdaiyishu:[],
                diaosu:[],
                guohua:[],
                shufa:[],
                taoci:[],
                tongqi:[],
                youhua:[],
                yushiqi:[],
                zisha:[],
                gujishanben:[],
                youpinqianbi:[],
                zhubaofeicui:[],
                mingbiao:[],
                mingjiu:[]

            },
            classAdvStatus:0,
            classAdv1:[],
            classAdv2:[],
            classAdv3:[],
            classAdv4:[],
            classAdv5:[],
            classAdv6:[],
            classAdv7:[],
            classAdv8:[],
        }
    },
    mounted() {
        this.t=Date.now()
        this.getClass()
    },
    components:{
        AdvClass
    },
    methods:{
        getClass(){
            getClass().then((res) => {
                this.classData = res.data
            });
        },
        authorClick(item) {
            authorClick(item.Id,item.Title)
            console.log('艺术点击',item.Id,item.Title);
        }
    }
}
</script>

<style scoped lang="scss">
/*拍卖类型*/
.hotList{
    .allyesAdvWrap{margin-top: 20px;}
    /deep/.el-tabs__header{margin-bottom: 0;}
    /deep/.el-tabs__active-bar{background-color: #329D15;height:2px;}
    /deep/.el-tabs__nav-wrap::after{display:none;}
    /deep/.el-tabs--top .el-tabs__item{height:40px;font-size: 14px;color:#595959;padding:0;line-height: 40px;padding-right: 30px;}
    /deep/.el-tabs--top .el-tabs__item:nth-child(2){padding-left: 0;}
    /deep/.el-tabs--top .el-tabs__item.is-active{color:#329D15;}
    ul{
        li{margin-top: 20px;
            .imgBox{overflow: hidden;border-radius: 4px;position: relative}
            .hotTit{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 16px;line-height: 24px;margin-top: 10px;}
            .hoverTxt{position: absolute;width:100%;height:100%;background-color: rgba(0,0,0,.65);display:flex;flex-direction:column;justify-content:center;color:#fff;font-size: 12px;line-height: 20px;top:100%;padding:0 40px;transition: .2s top ease-in-out;
                p{margin-bottom: 10px;}
                p:last-child{margin-bottom: 0;}
            }
        }
        .second{
            .hoverTxt{padding:0 14px;width:100%;}
        }
        li a:hover .hoverTxt{top:0;}
    }
    .first{
        a{height: 214px;display:block;background-color: #f2f2f2;display:flex;justify-content: center;align-items: center;position: relative;overflow: hidden;}
        img{width:100%;height:100%;object-fit: contain;}
    }
    .second{overflow: hidden;float:left;margin-right: 20px;width:180px;
        .imgBox{height:240px;}
    }
    .second:last-child{margin-right: 0;}

}
.oneTabs{
    /deep/.el-tabs--top .el-tabs__item{padding-right: 0;margin-right: 0;}
}
</style>